<template>
  <q-page class="q-px-xl q-pb-lg">
    <widget-header
      title="Matérias"
      whois="Matérias"
      :amount-for-query="totalRowsForQuery"
      :amount="totalRows"
    />
    <search-box
      entity="Matérias"
      :is-loading="loading"
      class="q-my-xl"
      @typing="handleSearch"
    >
      <action-button
        v-if="enableChanges"
        :label="`Adicionar Matéria`"
        @action-click="() => newTopicDialog = true"
      />
    </search-box>
    <q-infinite-scroll
      ref="infiniteScroll"
      :offset="250"
      @load="onScroll"
    >
      <q-list
        v-for="(item) in rootTopics"
        :key="item.id"
        class="q-mt-md rounded-borders"
        bordered
      >
        <topic-tree-item
          :id="item.id"
          :name="item.name"
          :has-children="item.has_children"
          :path="item.path"
        />
      </q-list>
    </q-infinite-scroll>
    <q-dialog
      v-model="newTopicDialog"
      persistent
    >
      <q-card class="column dialog-card">
        <div class="text-h6 q-pa-md">
          Adicionar matéria
        </div>
        <q-card-section
          class="full-width"
        >
          <div class="text-grey-7">
            Nome completo da matéria
          </div>
          <q-input
            ref="input"
            v-model="newTopicName"
            :rules="[notEmpty]"
            dense
            filled
          />
        </q-card-section>

        <q-card-actions class="text-primary row justify-end q-mb-sm">
          <q-btn
            outline
            label="Cancelar"
            @click.native="() => newTopicDialog = false"
          />
          <q-btn
            outline
            label="Salvar"
            @click.native="onNewTopicOk"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import WidgetHeader from '@/components/WidgetHeader';
import SearchBox from '@/components/SearchBox';
import ActionButton from '@/components/ActionButton';
import TopicTreeItem from '@/components/TopicTreeItem';
import { notEmpty } from '@/utils/validators';
import { verticalsInSyncCatalogs } from '@/utils/verticals_in_sync_catalogs';

export default {
  name: 'TopicList',
  components: {
    WidgetHeader,
    SearchBox,
    ActionButton,
    TopicTreeItem,
  },
  data: () => ({
    totalRowsForQuery: 0,
    totalRows: 0,
    page: 0,
    perPage: 2,
    isSearch: false,
    loading: false,
    rootTopics: [],
    newTopicDialog: false,
    newTopicName: '',
  }),
  computed: {
    enableChanges() {
      return !verticalsInSyncCatalogs.includes(sessionStorage.getItem('vertical'));
    },
  },
  methods: {
    notEmpty,
    async loadTopics() {
      this.loading = true;
      let resp = {};

      if (this.isSearch) {
        resp = await this.$services.topicsrest.search({
          page: this.page,
          perPage: this.perPage,
          query: this.searchTerm,
        });
      } else {
        resp = await this.$services.topicsrest.readAllMaster({
          page: this.page,
          perPage: this.perPage,
        });
      }

      this.rootTopics = [...this.rootTopics, ...resp.topics];

      this.totalRowsForQuery = resp.total;
      this.totalRows = resp.total;
      this.page++;
      this.loading = false;
      this.$refs.infiniteScroll.resume();
    },
    async onNewTopicOk() {
      this.newTopicDialog = false;
      await this.$services.topicsrest.createTopic(null, this.newTopicName);
      this.page = 0;
      this.rootTopics = [];
      await this.loadTopics();
      this.newTopicName = '';
      this.$q.notify('Cadastrado com sucesso!');
    },
    async handleSearch(term) {
      if (term === '') {
        this.isSearch = false;
        this.page = 0;
        this.rootTopics = [];
      } else if (term !== this.searchTerm) {
        this.isSearch = true;
        this.page = 0;
        this.rootTopics = [];
      }

      this.searchTerm = term;
      await this.loadTopics();
    },
    async onScroll(index, done) {
      await this.loadTopics();

      if (this.rootTopics.length >= this.totalRowsForQuery) {
        done(true);
        return;
      }

      done();
    },
  },
};
</script>
